"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    oss: `This tool is {link|open-source on GitHub|https://github.com/do-community/dns-tool} under the {link|Apache-2.0|https://github.com/do-community/dns-tool/blob/master/LICENSE} license! We welcome feedback and contributions.`,
};
